// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyDIE1PX5yfHj6xdjFDH5XnGE3tdMGLdnoA",
  authDomain: "videoai-kpoint.firebaseapp.com",
  projectId: "videoai-kpoint",
  storageBucket: "videoai-kpoint.firebasestorage.app",
  messagingSenderId: "303893749681",
  appId: "1:303893749681:web:7e7cc4a28f3bdf6a5aa790",
  measurementId: "G-8WQMDGKL3K"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
// const db = getFirestore(app);

export { app };